import {IdNome} from './id-nome.model';

export class FilaEsperaFiltro {
  atendimento?: IdNome
  sessao?: IdNome
}
